import React from "react";
import { Link } from "gatsby";

import styled from "styled-components";

import { StyledConfSubTitle, StyledConfDescSmall } from "../styles/StyledEGConf";

import rightArrow from "../images/right-arrow.svg";

const StyledRecordList = styled(props => <Link {...props} />)`
  background: #FFFFFF;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  display: block;
  transition: all .3s ease-in-out;
  &:hover {
    box-shadow: 0px 14px 60px rgba(0, 0, 0, 0.16);
    .list {
      .arrow {
        img {
          transform: translateX(5px);
        }
      }
    }
  }
  .thumbImg {
    img {
      border-radius: 8px 8px 0 0;
    }
  }
  .list {
    padding: 40px;
    padding-top: 32px;
    display: flex;
    align-items: flex-end;
    .flexOne {
      flex: 1;
    }
    .arrow {
      padding-left: 50px;
      img {
        width: 24px;
        transition: all .3s ease-in-out;
      }
      .imgBig {
        width: 40px;
      }
    }
  }
  @media (min-width: 768px) and (max-width: 991px) {
    position: relative;
    .list {
      padding: 24px;
      .flexOne {
        padding-right: 40px;
      }
      .arrow {
        padding-left: 40px;
        position: absolute;
        right: 24px;
        bottom: 28px;
      }
    }
  }
  @media (max-width: 767px) {
    .list {
      padding: 24px;
      .arrow {
        padding-left: 32px;
        .imgBig {
          width: 24px;
        }
      }
    }
  }
`;
const IndivRecord = ({recordings}) => {
  return (
    <StyledRecordList to={recordings.linkUrl}>
      <div className="thumbImg">
        <img src={recordings.recordThumb} alt="Thumb" />
      </div>
      <div className="list">
        <div className="flexOne">
          <StyledConfDescSmall pb="8px" fontBold="500" blueColor="#0079BD">{recordings.talkType}</StyledConfDescSmall>
          <StyledConfSubTitle pb="0px" blueColor="#1B2738">{recordings.title}</StyledConfSubTitle>
        </div>
        <div className="arrow">
          <img className={recordings.bigArrow ? "imgBig" : ""} src={rightArrow} alt="arrow" />
        </div>
      </div>
    </StyledRecordList>
  );
};
export default IndivRecord;
